<template>
<div class="bc_ico" v-if="'SUPPORT' === loginSystem">
    {{ $t('FIELD.GLOBAL.PAGEINFO.HOME') }}
    <template v-for="b in breads">
        <em>
            <span class="sr_only">&gt;</span>
        </em>
        {{ b.menuNm }}
    </template>
</div>
<div class="bc_ico" v-else>
    <a href="javascript:" @click="goMain">{{ $t('FIELD.GLOBAL.PAGEINFO.HOME') }}</a>
    <template v-for="b in breads">
        <em>
            <span class="sr_only">&gt;</span>
        </em>
        {{ b.menuNm }}
    </template>
</div>
</template>

<script>
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import store                    from '@/vuex/store';
import { SDLUtil, MenuUtil }    from '@/utils';
/**
 *  @description
 *  - 각 페이지의 MenuId 를 검색하여 Breadcrumbs 를 생성한다.
 *  - 우선순위
 *      1. 넘겨받은 menuId
 *      2. 메뉴를 클릭하여 생성된 menuId
 *         - 만약 뒤로가기 버튼을 눌러서 메뉴ID가 다른 경우, history-1 페이지가 우선시 된다.
 *         - 이러한 경우에는 history-1 URL을 내 권한 메뉴에서 검색하여 menuId 를 추출한다.
 *      ex) Service Menual 페이지에서 뒤로가기하여 My Knowledge 로 갔을 때, Service Menual Title 과 Breadscrumbs 가 출력되는 현상
 */
export default {
    name: 'SKPBreadcrumbs',
    props: {
        setMenuId: { default: '' }      // Menu List 에 등록되지 않은 페이지의 경우, MenuId 를 통해 다른 Breadcrumbs 를 가져올 수 있다.
    },
    data() {
        return {
            breads: [],
            selMenuNm: '',

            currMenuId: '',
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            params: 'getParams',
            loginSystem: 'getLoginSystem',
        }),
        getBreadcrumbs() {
            let scanMenuByUrls = MenuUtil.menuScanByUrl(this.$route.fullPath, this.menus);
            let scanMenuByUrl = _.find(scanMenuByUrls, function(m) { return m.currMenu === true; });
            let paramMenuId = this.params.menuId || '';

            // Current menuId === this.params.menuId;
            this.currMenuId = paramMenuId;

            // vuex 에 들어있는 menuId 와 URL로 검색한 menuId 가 다른 경우 (history-1)
            if(scanMenuByUrls) {
                if( paramMenuId !== scanMenuByUrl.menuId ) {
                    this.currMenuId = scanMenuByUrl.menuId;
                }
            };

            let breads = [],
                scanMenu = MenuUtil.menuScan(SDLUtil.nvl(this.setMenuId, this.currMenuId), this.menus);

            if(scanMenu) {
                scanMenu.forEach((menu) => { if(menu.currMenu){ this.selMenuNm = menu.menuNm; breads.push(menu); } });
                for(let i = 0; i < breads[0].depth; i++){
                    let menuPid = breads[i].menuPid;
                    scanMenu.forEach((menu) => { if(menuPid === menu.menuId) breads.push(menu); });
                }

                return _.sortBy(breads, ['depth']);
            };
        }
    },
    methods: {
        goMain() {
            store.commit( 'PARAMS', Object.assign( this.params, { menuId : '', menuGrpCd : '', menuGrpDetailCd : '', creationYn : null } ) );
            if(this.loginSystem == 'SUPPORT') {
                this.$router.push(MenuUtil.getSupportMain());

            } else {
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
            }
        }
    },
    created() {
        this.breads = this.getBreadcrumbs;
        // 현재 선택된 메뉴명을 전달한다.
        this.$emit('page-title', this.selMenuNm);
    }
};
</script>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/SKPBreadcrumbs.vue